export class MsalAzureTokenConstants {
  static GraphApiToken: string = 'msal.GraphApiToken';
  static FmsApiToken: string = 'msal.FmsApiToken';
  static FmsApiTokenError: string = 'Unable to fetch FMS Read token from Azure';
  static GraphApiTokenError: string = 'Unable to fetch FMS Graph Library token from Azure';
}